module.exports = __webpack_public_path__ + "static/media/line.2e378e28.jpg";